import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";

function ScenarioDialogue({ dialogue, index }) {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = () => {
    if (currentStep < dialogue.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };
  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <Card className="scenario-dialogue-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>{index}. Scenario-Based Question</Card.Title>
        <Card.Text>
          <strong>{dialogue[currentStep].speaker}:</strong>{" "}
          {dialogue[currentStep].text}
        </Card.Text>
        <Button
          variant="primary"
          size="md"
          onClick={handlePrev}
          style={{ marginRight: "10px" }}
          disabled={currentStep > 0 ? false : true}
        >
          Prev
        </Button>

        <Button
          variant="primary"
          onClick={handleNext}
          style={{ marginLeft: "10px" }}
          disabled={currentStep < dialogue.length - 1 ? false : true}
        >
          Next
        </Button>
      </Card.Body>
    </Card>
  );
}

export default ScenarioDialogue;
